export type EmailTemplateType = 'DEFAULT' | 'MINIMAL' | 'DETAILED' | 'SIMPLE' | 'MODERN';

export interface EmailTemplateOption {
  id: EmailTemplateType;
  label: string;
  description: string;
}

// Kept in sync with EmailService's TEMPLATE_* constants and template builders
// in ataserver -- 'DEFAULT' is the original always-existing report email.
export const EMAIL_TEMPLATE_OPTIONS: EmailTemplateOption[] = [
  { id: 'DEFAULT', label: 'Standard', description: 'The original report email with an Open Report button.' },
  { id: 'MINIMAL', label: 'Minimal', description: 'A plain-text style email with just the essentials and a report link.' },
  { id: 'DETAILED', label: 'Detailed Summary', description: 'A results table (suite, features, scenarios, steps, platform, iteration, duration, status, reason) with a report link per suite.' },
  { id: 'SIMPLE', label: 'Simple Summary', description: 'The same results table without features/scenarios/steps/reason -- just suite, platform, iteration, duration, status, and a report link.' },
  { id: 'MODERN', label: 'Modern', description: 'A card-style layout with a color-coded status banner.' },
];
